import React from 'react';
import { motion } from 'framer-motion';
import { Dices, Coins, Gift, Trophy, RotateCw } from 'lucide-react';
import styles from './UseCases.module.css';

const cases = [
  {
    icon: <Dices size={32} />,
    title: 'Solana Slot Machine',
    description: 'Build provably fair slot machines with instant payouts'
  },
  {
    icon: <Coins size={32} />,
    title: 'On-chain Coinflip',
    description: 'Create transparent coin flip games with verifiable outcomes'
  },
  {
    icon: <Gift size={32} />,
    title: 'Meme Lottery',
    description: 'Launch token-integrated lottery systems with custom mechanics'
  },
  {
    icon: <Trophy size={32} />,
    title: 'Progressive Jackpot',
    description: 'Implement growing prize pools with automated distributions'
  },
  {
    icon: <RotateCw size={32} />,
    title: 'Daily Spin + Airdrop Game',
    description: 'Create engaging daily reward systems with token airdrops'
  }
];

const UseCases = () => {
  return (
    <section className={`${styles.useCases} section`}>
      <div className="container">
        <motion.div
          className={styles.content}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className={styles.title}>Build Any Gambling DApp</h2>
          <p className={styles.subtitle}>
            From simple coin flips to complex progressive jackpots, GambleBase has you covered
          </p>
          
          <div className={styles.grid}>
            {cases.map((item, index) => (
              <motion.div
                key={index}
                className={styles.card}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
              >
                <div className={styles.icon}>{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default UseCases; 